export const ASSET_LIST_OR_MAP = 'ASSET_LIST_OR_MAP'
